import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatError } from "../lib/api";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err?.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F7F1E8] flex items-center justify-center px-6">
      <div className="relative w-full max-w-md p-8 md:p-10 rounded-[28px] bg-[#FDFAF3] border border-[#E5D9C0]">
        <p className="font-script text-2xl text-[#8D869B]">welcome back</p>
        <h1 className="font-serif-display text-3xl md:text-4xl mt-2 text-[#2D3640]">Porto · Admin</h1>
        <p className="text-sm text-[#4A5A6B] mt-3">Sign in to manage bookings and availability.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.22em] text-[#5E7891]">Email</Label>
            <Input data-testid="admin-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-2 bg-[#F7F1E8] border-[#E5D9C0]" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.22em] text-[#5E7891]">Password</Label>
            <Input data-testid="admin-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-2 bg-[#F7F1E8] border-[#E5D9C0]" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={busy}
            className="btn-sweep w-full inline-flex justify-center px-6 py-3 rounded-full bg-[#2D3640] text-[#FDFAF3] text-sm tracking-wider hover:bg-[#5E7891] disabled:opacity-60">
            {busy ? "..." : "Sign in"}
          </button>
        </form>

        <a href="/" data-testid="admin-back-home" className="block text-center mt-6 text-xs text-[#5E7891] hover:text-[#2D3640]">← back to the walk</a>
      </div>
    </div>
  );
}
